import { useEffect, useState } from 'react';

const initialStatePercentage = {
  parents: 0,
  students: 0,
  teachers: 0,
  assistants: 0,
};

const initialCollectedSurveys = {
  parents: 0,
  students: 0,
  teachers: 0,
  assistants: 0,
};

export const useCalcPercentageData = (surv, folders) => {
  const [percentage, setPercentage] = useState(initialStatePercentage);
  const [collectedSurveys, setCollectedSurveys] = useState(
    initialCollectedSurveys
  );

  const filterFolder = (rolName) => {
    const surveyFiltered = folders?.filter((folder) =>
      folder?.name?.toLowerCase().includes(rolName.toLowerCase())
    );
    return surveyFiltered;
  };
  const [surveyParents] = filterFolder('APODERADO');
  const [surveyStudents] = filterFolder('ESTUDIANTE');
  const [surveyTeachers] = filterFolder('DOCENTE');
  const [surveyAssistants] = filterFolder('ENCARGADO CONVIVENCIA');

  const calculatePercentage = (value1, value2) => {
    return value1 && value2 ? Math.round((value1 / value2) * 100) : 0;
  };

  useEffect(() => {
    setPercentage({
      parents: calculatePercentage(
        surveyParents?.completedResponses,
        surv?.parentsMin
      ),
      students: calculatePercentage(
        surveyStudents?.completedResponses,
        surv?.studentsMin
      ),
      teachers: calculatePercentage(
        surveyTeachers?.completedResponses,
        surv?.teachersMin
      ),
      assistants: calculatePercentage(
        surveyAssistants?.completedResponses,
        surv?.teachingAssistansMin
      ),
    });
  }, [
    surv,
    surveyParents,
    surveyStudents,
    surveyTeachers,
    surveyAssistants,
    folders,
  ]);

  useEffect(() => {
    setCollectedSurveys({
      parents: surveyParents?.completedResponses
        ? surveyParents?.completedResponses
        : 0,
      students: surveyStudents?.completedResponses
        ? surveyStudents?.completedResponses
        : 0,
      teachers: surveyTeachers?.completedResponses
        ? surveyTeachers?.completedResponses
        : 0,
      assistants: surveyAssistants?.completedResponses
        ? surveyAssistants?.completedResponses
        : 0,
    });
  }, [surveyParents, surveyStudents, surveyTeachers, surveyAssistants]);

  return {
    percentage,
    collectedSurveys,
    calculatePercentage,
  };
};
